<div class="page center">
  <ng-lottie [options]="{ path: '/assets/animations/product-icons/plus.json' }"></ng-lottie>
  <h1>We’ll be back soon!</h1>
  <p class="standard-text">Picflow is currently undergoing some planned maintenance to improve the service.</p>
  <p class="standard-text legal"><b>Note:</b> This page will refresh automatically when we’re back.</p>
</div>
